import moment from 'moment';
import _ from 'lodash';
import { DEFAULT_DATA } from '../constants/common';

const fromActualizationResponse = (response) => ({
  actualizationDate: moment(_.get(response, 'actualizationDate', DEFAULT_DATA)).isValid()
    ? moment(response.actualizationDate).valueOf()
    : DEFAULT_DATA,
  amountCalculatedDate: moment(_.get(response, 'amountCalculatedDate', DEFAULT_DATA)).isValid()
    ? moment(response.amountCalculatedDate).valueOf()
    : DEFAULT_DATA,
});

export default fromActualizationResponse;
